import { z } from 'zod';

export const basicInfoSchema = z.object({
  name: z.string().trim().min(1, { message: 'Name must be provided.' }),
  code: z.string().optional(),
  tokenLimit: z.number().optional(),
});

export const detailsSchema = z.object({
  issues: z.string().trim().min(1, { message: 'Issues must be provided.' }),
  disputeType: z.string().optional(),
  userDefinedEntities: z.string().optional(),
  additionalContext: z.string().optional(),
  timePeriod: z.string().optional(),
  disputeStatus: z.string().optional(),
});

export type BasicInfoForm = z.infer<typeof basicInfoSchema>;
export type DetailsForm = z.infer<typeof detailsSchema>;
